// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2RKQ_","header":"ReportDetails_header__3X5Xw","title":"ReportDetails_title__a0gpL","left":"ReportDetails_left__1Ql9h"};